// If we don't pass a valid HTML string to parse, it will not be happy about it.
export const containsHtmlTags = (str) => /<[^>]*>/g.test(str);
